import { render, staticRenderFns } from "./vipinfo.vue?vue&type=template&id=01b8d315&scoped=true&"
import script from "./vipinfo.vue?vue&type=script&lang=js&"
export * from "./vipinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8d315",
  null
  
)

export default component.exports